import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { setCarousals, setApiError } from "../../components/Carousal/CarousalSlice";
import Carousal from "../../components/Carousal/Carousal";
import Login from "../../pages/Login/Login";
import ResetPassword from "../ForgotPassword/ResetPassword";
import fetchCarousals from "../../services/CarousalAPI";
import './Welcome.css';
import {Globals} from "../../global/Globals";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import Toast from "../../components/Toast/Toast";
import CryptoUtils from "../../util/cryptoUtils";
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector";
import { useLanguage } from "../../context/Languagecontext";

const Welcome = () => {
    const dispatch = useDispatch();
    const navigate=useNavigate();
     const {languages} = useLanguage();
    const [reset,setReset]=useState(false);
    const [toast, setToast] = useState({open:false, status:'', title:""});
    useEffect(() => {
        let response;
        fetchCarousals().then((resp) => {
            response = resp;
            if (response.status === 200) {
                const payload = { data: response?.data?.content };
                dispatch(setCarousals(payload))
            }
        })
            .catch((error) => {
                const payload = { apiError: Globals.ERROR_MESSAGES.GENERIC_API_ERROR };
                dispatch(setApiError(payload));
                console.error("error", error)
            });
    },[languages])

    useEffect(()=>{
        const isCookiesAvailable=CryptoUtils.getFromCookie(Globals.JWT_TOKEN_NAME);
        if(isCookiesAvailable){
            navigate(Globals.NAVPATH.HOME);
        }
    })

    const renderToast = (status,title) =>{
        setToast({open:true, status:status,title:title});
        setTimeout(() => {
          setToast({open:false, status:'',title:''});
        }, 4000);
      }

    return (
        <>
            <div className="welcome-container">
                <div className="carousal-container">
                    <Carousal />
                </div>
                <div className="login-container">
                {reset ? <div className="login"><ResetPassword  renderToast={renderToast}/></div> : <div className="login"><Login setReset={setReset}/></div>}

                <div className="footer"><Footer /></div>
                </div>
            </div>
            {toast.open && <Toast status= {toast.status} onClose={()=>{setToast({open:false, status:'',title:''})}} title={toast.title} />}
        </>
    );
}
export default Welcome;